import React from "react";
import Modal from "components/global/modal";
import DetailedViewEdit from "./detailed-view-edit";

const DemoQuickEdit = ({
    title,
    date,
    buttons = [],
    positions = [],
    milestone,
    profile,
    cancelEdit,
    url,
    userData,
    group,
    updateMilestonesState,
    location="",
    platform="",
    hide = () => {},
}) =>{
    return(
        <Modal
              width="custom-with-responsive"
              contentClassName="rounded-lg overflow-auto custom-style"
              wrapperClassName="overflow-visible custom-style"
              centerModal="overflow-x-hidden"
              >
            <DetailedViewEdit
                buttons={buttons}
                title={title}
                positions={positions}
                milestone={milestone} 
                date={date}
                profile={profile}
                cancelEdit={hide}
                url = {url}
                userData={userData}
                updateMilestonesState={updateMilestonesState}
                group={group}
                platform={platform}
                location={location}
            />
        </Modal>
    )
}

export default DemoQuickEdit